import 'bootstrap';
import 'jquery-drawer';
// import Swiper from 'swiper';
(function($) {

    $('.drawer').drawer();

    const sliderThumbnail = new Swiper(".slider-thumbnail",{
        slidesPerView : 4,
    });
    const caseThumbnail1 = new Swiper("#recommend_thumbslider1",{
        slidesPerView : 4,
    });
    const caseThumbnail2 = new Swiper("#recommend_thumbslider2",{
        slidesPerView : 4,
    });
    const slider = new Swiper('.slider', {
        effect: 'slide',
        navigation: {
            nextEl:".slider .swiper-button-next",
            prevEl:".slider .swiper-button-prev"
        },
        thumbs: {
            swiper:sliderThumbnail
        },
        loop:true,
    });
    const caseslider1 = new Swiper('#recommend_slider1', {
        effect: 'slide',
        thumbs: {
            swiper:caseThumbnail1
        },
        loop:true,
    });
    const caseslider2 = new Swiper('#recommend_slider2', {
        effect: 'slide',
        thumbs: {
            swiper:caseThumbnail2
        },
        loop:true,
    });
    const swiperOptions = {
        loop : true,
        autoplay : {
            delay : 3000,
            disableOnInteraction : false
        },
        pagination : {
            el : '.case_slider .swiper-pagination',
            clickable : true
        },
        navigation : {
            nextEl : '.case_slider .swiper-button-next',
            prevEl : '.case_slider .swiper-button-prev',
        },
        breakpoints : {
            768 :{
                slidesPerView : 3,
                spaceBetween : 10,
            }
        }
    }
    const swiperOptions1 = {
        loop : true,
        autoplay : {
            delay : 3000,
            disableOnInteraction : false
        },
        navigation : {
            nextEl : '.pickup_slider .swiper-button-next',
            prevEl : '.pickup_slider .swiper-button-prev',
        },
        pagination : {
            el : '.pickup_slider .swiper-pagination',
            clickable : true
        },
        breakpoints : {
            768 :{
                slidesPerView : 3,
                spaceBetween : 10,
            }
        }
    }

    const caseSwiper = new Swiper('.case_slider',swiperOptions);
    const pickupSwiper = new Swiper('.pickup_slider',swiperOptions1);
    const mvSliderew = new Swiper('#mv',{
        loop : true,
        speed : 1500,
        autoplay : {
            delay : 1500,
        },
        pagination : {
            el : '#mv .swiper-pagination',
            clickable : true
        },
        effect : 'fade'
    });
})(jQuery);

$(function(){
    $('.accordion').on('click',function(){
        $(this).toggleClass('active');
        $(this).next('dd').slideToggle();
    });
    $('.page_link').on('click',function(e) { /* ①クリックアクションを設定 */
        e.preventDefault; /* ⑦falseを返し、URLに影響を与えないようにする */
        var speed = 200; /* ②スクロールの速さを指定 */
        var href= $(this).attr('href'); /* ③クリックするリンクの位置の値を取得 */
        var target = $(href == "#" || href == "" ? 'html' : href); /* ④スクロール先を取得 */
        var position = target.offset().top; /* ⑤ページのトップからスクロール先までの位置を数値として取得 */
        $('body,html').animate({scrollTop: position}, speed, 'linear'); /* ⑥スクロールのアニメーション設定 */
    });
    $('#create_tab li').on('click',function(){
        let num = $(this).index();
        $('#create_tab li').removeClass('active');
        $(this).addClass('active');
        $('.tab>div').addClass('hide');
        $('.tab>div').eq(num).removeClass('hide');
    });
    
    let fixed_top = $('#header_bottom').offset().top;
    let w_inner = $(window).innerWidth();
    $('.headernav_box').css('width',w_inner);
    $(window).on('resize',function(){
        w_inner = $(window).innerWidth();
        fixed_top = $('#header_bottom').offset().top;
        $('.headernav_box').css('width',w_inner);
    });
    $(window).on('scroll',function(){
        let scroll = $(this).scrollTop();
        if(fixed_top < scroll){
            $('#header_bottom').css('position','fixed');
        }else{
            $('#header_bottom').css('position','static');
        }
    });
    $('p.nav-link').on('click',function(){
        $(this).toggleClass('active');
        $(this).next('div').slideToggle();
    });
});